// extracted by mini-css-extract-plugin
export default {"pagination":"styles_pagination__8YGJY","remove":"styles_remove__Nv4r1","removeContainer":"styles_removeContainer__pIMOJ","name":"styles_name__t8v7d"};